import cubeMgmtSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const cubeMgmtActions = { ...actions, ...thunkActions };
export * as CubeMgmtTypes from './types';
export default cubeMgmtSlice;
